export default {
  payWelfareText: 'โบนัสเติมเงิน',
  blackFridayDiscount: 'ลดกระหน่ำ แบล็คฟรายเดย์',
  shareGift: 'แชร์ทันทีมีรางวัล',
  vipWeeklyWelfare: 'โปรฯ VIP ประจำสัปดาห์',
  exchangeCoupon: 'แลกคูปอง',
  firstPayOff: 'ซื้อครั้งแรก รับส่วนลดสูงสุด 15%',
  blackFridayEvent: 'กิจกรรมแบล็คฟรายเดย์',
  limitedTimeOff: 'ลดทันที 10%',
  claimCoupon: 'รับคูปอง',
  blackFridayTimedCoupon: 'คูปองแบล็คฟรายเดย์',
  timeLeft: 'เหลือเวลา:',
  claimTimeCoupon: 'รับคูปองลด 10% จำนวนจำกัด',
  points: 'คงเหลือพอยท์: ${point}',
  costPointTip: 'ใช้พอยท์รับคูปองระดับใดก็ได้',
  maxPointTip: 'ใช้ได้สูงสุดบัญชีละ 500 พอยท์',
  discountOff: 'ลด 10%',
  highestDiscount: 'ลดสูงสุด ${discount} ',
  needPoint: 'ต้องใช้พอยท์ ${point}',
  changeCurrency: 'เปลี่ยนสกุลเงิน',
  claim: 'รับ',
  claimSucc: 'รับสำเร็จ',
  claimFail: 'รับล้มเหลว',
  pointNotEnough: 'พอยท์ไม่เพียงพอ',
  afterClaimPoint: 'หลังรับจะเหลือพอยท์: ${point}',
  footTips1: 'ใช้คูปองได้ 1 ใบ/1 การสั่งซื้อ',
  footTips2: 'ใช้คูปองนี้ร่วมกับคูปองเงินสดไม่ได้',
  footTips3:
    'ทีมงานขอสงวนสิทธิ์ในการแก้ไขเปลี่ยนแปลงเงื่อนไขโดยไม่ต้องแจ้งให้ทราบล่วงหน้า',
  ruleTitleText: 'กติกา',
  ruleTime: 'ระยะเวลา: 24 พ.ย. เวลา 00:00 น.- 26 พ.ย. เวลา 23:59 น.(UTC)',
  bfRuleText1:
    '1. ล็อกอินหน้าเว็บเติมเงินทางการครั้งแรกในช่วงกิจกรรม จะได้รับ 400 พอยท์ สามารถนำไปใช้แลกคูปองได้ สูงสุด 500 พอยท์',
  bfRuleText2:
    '2. ช่วงกิจกรรมสามารถใช้พอยท์แบล็คฟรายเดย์แลกคูปองยอดใดก็ได้ ยอดยิ่งสูง ยิ่งต้องใช้พอยท์มากตาม หลังแลกสำเร็จ จะหักพอยท์จำนวนที่สอดคล้อง',
  bfRuleText3:
    '3. ทุกๆ การสั่งซื้อใช้คูปองได้เพียง 1 ใบ และไอเทมคูปองเงินสดไม่สามารถใช้คูปองแบล็คฟรายเดย์',
  bfRuleText4: '4. คูปองแบล็คฟรายเดย์สนับสนุนสกุลเงินดังนี้ :',
  ableCoinsType:
    'USD, JPY, KRW, TWD, EUR, HKD, GBP, CAD, AUD, RUB, MYR, THB, PLN, IDR',
  bfRuleText5:
    '5. หลังแลกสำเร็จจะไม่สามารถเปลี่ยนสกุลเงินหรือขอคืนพอยท์ได้ โปรดตรวจสอบยอดเงินและการใช้พอยท์ก่อนแลก',
  bfRuleText6: '6. คูปองแบล็คฟรายเดย์มีอายุ 7 วัน',
  bfRuleText7:
    '7. ทีมงานขอสงวนสิทธิ์ในการแก้ไขเปลี่ยนแปลงเงื่อนไขโดยไม่ต้องแจ้งให้ทราบล่วงหน้า',
  thanksTip:
    'ขอบคุณสำหรับการสนับสนุน สามารถติดตามกิจกรรมเพิ่มเติมได้ทางโซเชียลของเรา',
  exchangePoints: 'แลกคูปอง',
  exchangeCode: 'โปรดเลือกช่องทางชำระเงินและป้อนโค้ดส่วนลด',
  enterExchangeCode: 'ป้อนโค้ดส่วนลดที่นี่',
  exchangeText: 'แลก',
  confirmGet: 'ยืนยันรับ',
  couponUsedWay:
    'สามารถใช้คูปองกับช่องทางชำระเงินของสกุลเงินที่กำหนดได้เท่านั้น โปรดยืนยันสกุลเงินที่ท่านต้องการใช้',
  confirmText: 'ยืนยัน',
  exchangeSucc: 'แลกสำเร็จ',
  aboutCoins: 'เกี่ยวกับคูปองเงินสด',
  aboutCoinsText:
    'คูปองเงินสดใช้แลกแพ็กและบริการเสริมทุกประเภทของเกมนี้ได้ ยกเว้นคูปอง',
  known: 'ทราบแล้ว',
  codeText: 'กิ๊ฟโค้ด',
  codeInvalid: 'กิ๊ฟโค้ดไม่เป็นผล!',
  hasExchanged: 'ท่านเคยแลกไปแล้ว สามารถแลกได้เพียง 1 ครั้ง!',
  hideText: 'ซ่อน',
  //黑五的报错码
  'bf-20001': 'ยังไม่ได้ล็อกอิน',
  'bf-20002': 'พารามิเตอร์ผิดพลาด โปรดลองร่วมกิจกรรมใหม่',
  'bf-20003': 'พอยท์ไม่เพียงพอ',
  'bf-20004': 'รับไม่สำเร็จ โปรดลองใหม่ภายหลังหรือติดต่อฝ่ายบริการลูกค้า',
  'bf-20005': 'รับแล้ว',
  'bf-20015': 'กิจกรรมยังไม่เริ่ม โปรดติดตาม',
  'bf-20016': 'กิจกรรมสิ้นสุดแล้ว',
  bfShareText: 'รับคูปองลด 10% จำนวนจำกัด',
  rightsCenterBtn: 'ศูนย์สมาชิก',
  payBtn: 'เติมเงิน',
  hasEqualRewardMuglo: 'เติมเงินผ่านเว็บเกม ได้รับโบนัสสูงสุด 1800 เพชร!',
  productInterceptPopupTitle: 'Purchase Failed',
  productInterceptPopupTip: 'This item is not available in your region.<br>Please contact customer support if you have any questions.',
  productInterceptPopupConfirm: 'OK',
  vipHeadAwardText285 : 'เกียรติยศเหนือล้ำ(ถาวร)',
  '-': '-'
};
